const CatalogViewLoader = () => {
  return ( 
    <p>Loading stories...</p>
  );
}
 
export default CatalogViewLoader;